export interface ITextEnhancements {
  input: string;
  action: ITextEnhancementsActionTypes;
}

export type ITextEnhancementsResponse = {
  text: string;
};

export type ITextEnhancementsActionTypes =
  | "makeMorePolite"
  | "makeMoreFormal"
  | "makeMoreElaborate"
  | "makeMoreCasual"
  | "correct";

export enum TextEnhancement {
  MORE_POLITE = "makeMorePolite",
  MORE_FORMAL = "makeMoreFormal",
  MORE_ELABORATE = "makeMoreElaborate",
  MORE_CASUAL = "makeMoreCasual",
  CORRECT_GRAMMAR = "correct",
}
